import "./document-to-pdf.css";
import "./markdown-to-pdf.css";
import { renderDocumentPreview } from "./document-preview.js";
import { initializeDocumentPdfTool } from "./document-to-pdf-ui.js";
import { decodeRtfBytes, parseRtfDocument } from "./rtf-document-parser.js";

initializeDocumentPdfTool({
  mode: "rtf",
  parseSource: parseRtfDocument,
  renderPreview: renderDocumentPreview,
  decodeFile: decodeRtfBytes
});
